/** Соответствует server/src/contracts/wsClose.js — коды закрытия WebSocket (Colyseus). */
export const WS_CLOSE_DUPLICATE = 4001;
export const WS_CLOSE_MATCH_ABORTED = 4405;
export const WS_CLOSE_AFK_MATCH_ABORTED = 4406;
/** Не нажали «Готов к реваншу» в срок (онлайн-белот). */
export const WS_CLOSE_BELOT_REMATCH_READY_TIMEOUT = 4407;

/** Синхронно с server/src/contracts/wsClose.js WS_CLOSE_UX_KIND. */
export const WS_CLOSE_UX_KIND = Object.freeze({
  DUPLICATE_SESSION: 'duplicate_session',
  MATCH_ABORTED: 'match_aborted',
  AFK_MATCH_ABORT: 'afk_match_abort',
  BELOT_REMATCH_TIMEOUT: 'belot_rematch_timeout',
});

/**
 * Второй клиент с тем же userId: сервер закрывает старое соединение без allowReconnection.
 * Нельзя вызывать reconnect/joinById в цикле — получаются «качели» между устройствами.
 * @param {number|string} code
 * @param {string} [reason]
 */
export function isDuplicateSessionKick(code, reason) {
  return (
    Number(code) === WS_CLOSE_DUPLICATE ||
    String(reason || '').toLowerCase().includes('duplicate')
  );
}

export function isMatchAbortKick(code, reason) {
  const r = String(reason || '').toLowerCase();
  return (
    Number(code) === WS_CLOSE_MATCH_ABORTED ||
    Number(code) === WS_CLOSE_AFK_MATCH_ABORTED ||
    r.includes('match_aborted') ||
    r.includes('afk_match_abort')
  );
}

/** Закрытие из‑за AFK (тот же сценарий возврата в лобби, другое сообщение). */
export function isAfkMatchAbortKick(code, reason) {
  const r = String(reason || '').toLowerCase();
  return Number(code) === WS_CLOSE_AFK_MATCH_ABORTED || r.includes('afk_match_abort');
}

export function isBelotRematchTimeoutKick(code, reason) {
  const r = String(reason || '').toLowerCase();
  return Number(code) === WS_CLOSE_BELOT_REMATCH_READY_TIMEOUT || r.includes('belot_rematch_ready_timeout');
}
